<template>
  <base-action-button @action="load">
    <template #prepend><PhChats style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
    {{ $store.getters.translate("messages") }}
  </base-action-button>
  <base-draggable-modal
      name="base_notification"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="base_notification">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate("messages") }}</v-toolbar-title>
            <v-spacer/>
            <v-btn size="small" @click="closeModal('base_notification');">
              <v-icon icon="mdi-close" size="x-large"/>
            </v-btn>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-toolbar flat color="white" density="default">
              <v-autocomplete
                  class="reg-normal text-primary"
                  base-color="border-tertiary"
                  bg-color="secondary"
                  density="default"
                  v-model="selected_message_template"
                  :items="message_templates"
                  @update:model-value="setText"
                  :return-object="true"
                  item-value="message"
                  item-title="name"
                  hide-details
                  single-line>
                <template #label>
                  <span class="sm-normal text-subtle">{{ $store.getters.translate('template') }}</span>
                </template>
              </v-autocomplete>
            </v-toolbar>
            <v-textarea
                density="default"
                class="reg-normal text-primary mt-5"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.message"
                hide-details
                flat
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('message') }}</span>
              </template>
            </v-textarea>
            <v-data-table
                :headers="headers"
                :items="notifications"
                class="elevation-1 mt-5"
                v-bind="footer_props"
                :show-select="false">
              <template #body="{ items }">
                <tr v-for="item in items" :key="item.id" class="sm-normal text-primary">
                  <td class="pa-3" v-html="item.data.message"/>
                  <td style="text-align: center;">{{ item.created_at ? moment(item.created_at).format("DD-MM-YYYY") : "-" }}</td>
                  <td style="text-align: center;">{{ item.read_at ? moment(item.read_at).format("DD-MM-YYYY") : "-" }}</td>
                  <!--ACTION BUTTONS-->
                  <td style="text-align: center; width: 80px;">
                    <v-menu>
                      <template #activator="{ props }">
                        <v-btn elevation="0" icon v-bind="props">
                          <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="deleteNotification(item.id)">
                          <template #prepend><PhTrash size="24"/></template>
                          <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="closeModal('base_notification');">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("close") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="saveTemplate">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhPaperPlaneRight style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("send") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhChats, PhDotsThreeVertical, PhPaperPlaneRight, PhTrash, PhX, PhFloppyDisk} from "@phosphor-icons/vue";

export default {
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhFloppyDisk, PhX, PhPaperPlaneRight, PhTrash, PhDotsThreeVertical, PhChats,
  },
  props: ["user_id"],
  data() {
    return {
      page: helpFunctions.pages.notifications,
      record: {},
      notifications: [],
      message_templates: [],
      selected_message_template: null,
      headers: [
        { title: this.$store.getters.translate("message"), align: "start", sortable: false, value: "data", width: "80%" },
        { title: this.$store.getters.translate("created_at"), align: "center", sortable: true, value: "created_at" },
        { title: this.$store.getters.translate("read"), align: "center", sortable: true, value: "read_at" },
        { title: "", align: "center", sortable: false, value: "actions", "width": "80px" },
      ],
      footer_props: helpFunctions.footer_props,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.record = {};
      this.openModal('base_notification');
      this.notifications = await helpFunctions.getCustomRoute(this.$toast, "notifications?user_id=" + this.user_id, false);
      if(this.message_templates.length === 0) {
        await this.getMessageTemplates();
      }
    },
    async getMessageTemplates() {
      this.message_templates = await helpFunctions.getCustomRoute(this.$toast, "messagetemplates", false);
    },
    async save() {
      let usual_fields_required = [{name: 'message', mandatory: true}];
      if (helpFunctions.modelFieldsFilled(this.$toast, this.record, usual_fields_required)) {
        this.record.user_id = this.user_id;
        await helpFunctions.createModel(this.$toast, this.page.name, this.record);
        await this.load();
      }
    },
    async saveTemplate() {
      let usual_fields_required = [{name: 'message', mandatory: true}];
      if (helpFunctions.modelFieldsFilled(this.$toast, this.record, usual_fields_required)) {
        await helpFunctions.createModel(this.$toast, 'messagetemplates', this.record);
        this.record = {};
        await this.getMessageTemplates();
      }
    },
    async deleteNotification(id) {
      await helpFunctions.deleteModel(this.$toast, this.page.name, id);
      await this.load();
    },
    setText() {
      if(this.selected_message_template) {
        this.record.message = this.selected_message_template.message;
      }
      else {
        this.record.message = '';
      }
    }
  },
};
</script>